

































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { onlyNumber } from '@/utils/common'

@Component

export default class ComponentRemuneracaoGeracaoRepasseRightNavBar extends Vue {
  $refs: {
    menu: any,
  }

  fltLoading: boolean = false
  menu: boolean = false

  get status() {
    return this.getStore.statusList
  }

  get selectedTipo() {
    return this.getStore.selectedTipo
  }

  set selectedTipo(value) {
    this.getStore.setSelectedPrestador(value)
  }

  get getTiposList() {
    return this.getStore.tipoEnum
  }

  get filterLoading() {
    return this.fltLoading
  }

  set filterLoading(value: boolean) {
    this.fltLoading = value
  }

  get getStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get drawer() {
    return this.getStore.geracaoDrawer
  }

  set drawer(value: boolean) {
    this.getStore.setGeracaoDrawer(value)
  }

  get tipo() {
    return this.getStore.selectedTipo
  }

  set tipo(value: any) {
    this.getStore.setSelectedTipo(value.key)
  }

  get getMenu() {
    return this.menu
  }

  set getMenu(value: boolean) {
    this.menu = value
  }

  get anoMesReferencia() {
    return this.getStore.anoMesReferencia
  }

  set anoMesReferencia(value) {
    this.getStore.setAnoMesReferencia(value)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async search() {
    this.filterLoading = true
    await this.getStore.getGeracaoRepasseAll()
    this.getStore.setFilterOn(this.hasAnyFilter())
    this.filterLoading = false
  }


  async selectTipo(item: any) {
    this.tipo = item
  }

  hasAnyFilter(): boolean {
    return this.getStore.selectedStatus.length > 0 || this.getStore.selectedTipo.length > 0
  }

  async clear() {
    this.getStore.clearFilterGeracaoRepasse()
    this.getStore.setFilterOn(false)
    await this.search()
  }

  windowHeight: number = 0

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      this.windowHeight = doc.documentElement.clientHeight
    }
  }

  async mounted() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }

  async updated() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }
}
